module.exports = __webpack_public_path__ + "static/img/blog1.3feae857.jpg";